export default __webpack_public_path__ + "static/media/img (2).8c09dea8.jpg";